module.exports = __webpack_public_path__ + "img/link-simple.be8aa5b7.svg";